import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button';

import discountImg1 from '../../assets/img/newsletter/discount-1-1.png';
import discountImg2 from '../../assets/img/newsletter/discount-1-2.png';

const Discount = () => {
  return (
    <div className="it-discount-area fix p-relative pb-100 pt-120">
      <div className="container">
        <div className="row gx-35">
          <div
            className="col-xl-6 col-lg-6 mb-30 wow animate__fadeInLeft"
            data-wow-duration=".9s"
            data-wow-delay=".5s"
          >
            <div className="it-discount-item z-index p-relative fix">
              <div className="it-discount-content">
                <span className="it-section-subtitle-5 sky">30% OFF</span>
                <h4 className="it-discount-title">
                  DAILY DEAL OF <br />
                  THE DAY
                </h4>
                <Link className="shop-btn it-btn-theme" to="/cart">
                  <Button btnText="Shop now" />
                </Link>
              </div>
              <div className="it-discount-thumb">
                <img src={discountImg1} alt="" />
              </div>
            </div>
          </div>
          <div
            className="col-xl-6 col-lg-6 mb-30 wow animate__fadeInRight"
            data-wow-duration=".9s"
            data-wow-delay=".7s"
          >
            <div className="it-discount-item z-index p-relative fix">
              <div className="it-discount-content">
                <span className="it-section-subtitle-5 sky">35% OFF</span>
                <h4 className="it-discount-title">
                  ALL TYPE OF <br /> MASKS
                </h4>
                <Link className="shop-btn it-btn-theme" to="/cart">
                  <Button btnText="Shop now" />
                </Link>
              </div>
              <div className="it-discount-thumb style-2">
                <img src={discountImg2} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Discount;
